import { Badge } from "@/components/ui/badge";
import type { Owner } from "../types";

interface UserNameColumnProps {
  row: Owner;
}

export const UserNameColumn = ({ row }: UserNameColumnProps) => {
  return (
    <div className="flex flex-col">
      <span>{row.full_name || "N/A"}</span>
      <Badge variant="outline" className="w-fit mt-1">
        {row.user_type || "N/A"}
      </Badge>
    </div>
  );
};